import { useState } from "react";
import { submitDecision } from "../services/approvalApi";

export default function ApprovalModal({ data, onClose, refresh }: any) {
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  const act = async (decision: "approved" | "rejected") => {
    setLoading(true);
    await submitDecision(data.approval_id, decision, note);
    setLoading(false);
    refresh();
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h2>Review Draft</h2>

        <p><b>Content:</b></p>
        <p>{data.content}</p>

        <p><b>Risk:</b> {data.risk?.score}</p>

        <textarea
          placeholder="Approval note..."
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />

        <div className="actions">
          <button onClick={() => act("approved")} disabled={loading}>
            Approve
          </button>
          <button onClick={() => act("rejected")} className="danger">
            Reject
          </button>
        </div>
      </div>
    </div>
  );
}
